import accessibility from "../icons/accessibility.svg";
import accessibilityVar2 from "../icons/accessibility-variant-2.svg";
import accessibilityVar3 from "../icons/accessibility-variant-3.svg";
import accessibilityVar4 from "../icons/accessibility-variant-4.svg";
import largePointer from "../icons/large-pointer.svg";
import shieldSafe from "../icons/shield-safe.svg";
import eyeOpen from "../icons/eye-open.svg";
import eyeClosed from "../icons/eye-closed.svg";
import targetFocus from "../icons/target-focus.svg";
import adhdFriendly from "../icons/adhd-friendly.svg";
import pauseCircle from "../icons/pause-circle.svg";
import pauseMotion from "../icons/pause-motion.svg";
import readingAid from "../icons/reading-aid.svg";
import boldText from "../icons/bold-text.svg";
import lineSpacing from "../icons/line-spacing.svg";
import letterSpacing from "../icons/letter-spacing.svg";
import dyslexiaFont from "../icons/dyslexia-font.svg";
import highlightLinks from "../icons/highlight-links.svg";
import highlightTitle from "../icons/highlight-title.svg";
import contrast from "../icons/contrast.svg";
import darkContrast from "../icons/dark-contrast.svg";
import lightContrast from "../icons/light-contrast.svg";
import invertColors from "../icons/invert-colors.svg";
import saturation from "../icons/saturation.svg";
import lowSaturation from "../icons/low-saturation.svg";
import highSaturation from "../icons/high-saturation.svg";
import reset from "../icons/reset.svg";
import close from "../icons/close.svg";
import adjustFontSize from "../icons/adjust-font-size.svg";
import textScaleMinus from "../icons/text-scale-minus.svg";
import textScalePlus from "../icons/text-scale-plus.svg";
import hideImages from "../icons/hide-images.svg";
import accessibilityReport from "../icons/accessibility-report.svg";
import annotations from "../icons/annotations.svg";
import textToSpeech from "../icons/text-to-speech.svg";
import highContrast from "../icons/high-contrast.svg";
import simplifyLayout from "../icons/simplify-layout.svg";
import muteSounds from "../icons/mute-sounds.svg";
import textMagnifier from "../icons/text-magnifier.svg";
import pageStructure from "../icons/page-structure.svg";
import language from "../icons/language.svg";
import cognitive from "../icons/cognitive.svg";
import motorImpaired from "../icons/motor-impaired.svg";
import accessibilityProfile from "../icons/accessibility-profile.svg";
import textSize from "../icons/text-size.svg";
import color from "../icons/colors.svg";
import readingHelp from "../icons/reading-help.svg";
import comfort from "../icons/comfort.svg";
import easyReadFont from "../icons/easy-read-font.svg";
import search from "../icons/search.svg";
import playCircle from "../icons/play-circle.svg";

export const WIDGET_ICONS = {
  accessibility,
  accessibilityVariants: {
    default: accessibility,
    "icon-2": accessibilityVar2,
    "icon-3": accessibilityVar3,
    "icon-4": accessibilityVar4,
  },
  largePointer,
  shieldSafe,
  eyeOpen,
  eyeClosed,
  targetFocus,
  adhdFriendly,
  pauseCircle,
  pauseMotion,
  readingAid,
  boldText,
  lineSpacing,
  letterSpacing,
  dyslexiaFont,
  highlightLinks,
  highlightTitle,
  contrast,
  darkContrast,
  lightContrast,
  invertColors,
  saturation,
  lowSaturation,
  highSaturation,
  reset,
  close,
  adjustFontSize,
  textScaleMinus,
  textScalePlus,
  hideImages,
  accessibilityReport,
  annotations,
  textToSpeech,
  highContrast,
  simplifyLayout,
  muteSounds,
  textMagnifier,
  pageStructure,
  language,
  cognitive,
  motorImpaired,
  accessibilityProfile,
  textSize,
  color,
  readingHelp,
  comfort,
  easyReadFont,
  search,
  playCircle,
};
